module.exports = __webpack_public_path__ + "static/logo_1100_108-cd705ee7e6ffba68386c027829b9fd50.png";